module.exports = __webpack_public_path__ + "img/icon-loader-basa3.af47099c.svg";